var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleWithFlap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 12.1842V1.5H59.3585H67V12.1842M13 12.1842V41.693L38.9811 59.5C48.3208 53.9035 67 42.7105 67 42.7105V12.1842M13 12.1842L41.0189 22.8684L67 12.1842",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5768 28.2812L34.2526 33.2422L36.9284 28.2812H40.278L36.1471 35.332L40.3854 42.5H37.0065L34.2526 37.4414L31.4987 42.5H28.1002L32.3483 35.332L28.2077 28.2812H31.5768ZM51.3236 40.3027V42.5H41.597V40.625L46.1966 35.6934C46.6589 35.179 47.0235 34.7266 47.2904 34.3359C47.5573 33.9388 47.7494 33.584 47.8666 33.2715C47.9903 32.9525 48.0521 32.6497 48.0521 32.3633C48.0521 31.9336 47.9805 31.5658 47.8373 31.2598C47.694 30.9473 47.4824 30.7064 47.2025 30.5371C46.9291 30.3678 46.5905 30.2832 46.1869 30.2832C45.7572 30.2832 45.3861 30.3874 45.0736 30.5957C44.7676 30.804 44.5332 31.0938 44.3705 31.4648C44.2142 31.8359 44.1361 32.2559 44.1361 32.7246H41.3138C41.3138 31.8783 41.5157 31.1035 41.9193 30.4004C42.3229 29.6908 42.8926 29.1276 43.6283 28.7109C44.364 28.2878 45.2364 28.0762 46.2455 28.0762C47.2416 28.0762 48.0814 28.2389 48.765 28.5645C49.4551 28.8835 49.9759 29.3457 50.3275 29.9512C50.6856 30.5501 50.8646 31.2663 50.8646 32.0996C50.8646 32.5684 50.7897 33.0273 50.64 33.4766C50.4903 33.9193 50.2754 34.362 49.9955 34.8047C49.722 35.2409 49.39 35.6836 48.9994 36.1328C48.6087 36.582 48.1758 37.0475 47.7005 37.5293L45.2298 40.3027H51.3236Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleWithFlap);
export default __webpack_public_path__ + "static/media/double_with_flap.97026bc7ab689e7d4f140769bfe8edc4.svg";
export { ForwardRef as ReactComponent };